import { render, staticRenderFns } from "./AlternativeNames.vue?vue&type=template&id=00b0e262&scoped=true"
import script from "./AlternativeNames.vue?vue&type=script&lang=js"
export * from "./AlternativeNames.vue?vue&type=script&lang=js"
import style0 from "./AlternativeNames.vue?vue&type=style&index=0&id=00b0e262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b0e262",
  null
  
)

export default component.exports